<script setup>
import { ref, computed, onMounted } from "vue";
import { useTippy } from "vue-tippy";

const props = defineProps({
    logId: {
        type: String,
        default: null,
    },
});

const logIdRef = ref(null);
const wasCopied = ref(false);
const tooltipText = computed(() => {
    return wasCopied.value ? "Скопировано!" : "Скопировать";
});
let showTooltip = null;

onMounted(async () => {
    const { show } = useTippy(logIdRef, {
        content: tooltipText,
        arrow: true,
        appendTo: () => document.body,
        placement: "top",
        theme: "dark",
        trigger: "manual",
        zIndex: 999999999,
    });

    showTooltip = show;
});

const copy = async () => {
    await navigator.clipboard.writeText(props.logId);
    wasCopied.value = true;
    showTooltip();
};
</script>

<template>
    <span class="notifications-error-log-id" ref="logIdRef" @click="copy">
        {{ logId }}
    </span>
</template>

<style lang="scss" scoped>
.notifications-error-log-id {
    font-weight: 500;
    text-decoration: underline;

    cursor: pointer;

    &:hover {
        color: var(--c-danger);
    }
}
</style>
